//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { CommConfig } from 'src/app/core/models/system/communication/comm-config';
import { CommConfigDTO } from 'src/app/core/models/system/communication/comm-config.dto';
import { CommunicationTemplate } from 'src/app/core/models/system/communication/communication-template';
import { CommunicationTemplateAllocation } from 'src/app/core/models/system/communication/communication-template-allocation';
import { CommunicationTemplateDTO } from 'src/app/core/models/system/communication/communication-template.dto';
import { CommunicationTemplateReplacements } from 'src/app/core/models/system/communication/communication-template-replacements';
import { CommunicationTemplatesDefaults } from 'src/app/core/models/system/communication/communication-templates-defaults';
import { CommunicationTemplatesDefaultsDTO } from 'src/app/core/models/system/communication/communication-templates-defaults.dto';
import { EncryptionService } from '../../general/encryption-service';
import { eSimApiPaths } from 'src/app/core/consts';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../../general/exceptions-service';
import { forkJoin, Observable, of, switchMap } from 'rxjs';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class CommConfigService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
    
  public getForCompany(companyId: number): Observable<CommConfigDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<CommConfigDTO[]>(environment.eSimApi +
                                                                               eSimApiPaths.CommConfig + "/" +
                                                                               eSimApiPaths.CommConfigForCompany +
                                                                               "?companyIdEncSS=" + companyIdEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getForCompanyAlert(companyId: number, alertId: number): Observable<CommConfigDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<CommConfigDTO[]>(environment.eSimApi +
                                                                               eSimApiPaths.CommConfig + "/" +
                                                                               eSimApiPaths.CommConfigForCompanyAlert +
                                                                               "?companyIdEncSS=" + companyIdEncSS + '&alertId=' + alertId, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getCommunicationTemplate(companyId: number, messageTypeId: number, deliveryTypeId: number): Observable<CommunicationTemplateDTO> {
    try {
      return forkJoin({
               companyIdEncResult     : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true),
               deliveryTypeIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>deliveryTypeId),
               messageTypeIdEncResult : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>messageTypeId),
            })
            .pipe(
              switchMap(({ companyIdEncResult, deliveryTypeIdEncResult, messageTypeIdEncResult }) => {
                const companyIdEncSS   =companyIdEncResult.result;
                const deliveryTypeIdEnc=deliveryTypeIdEncResult.result;
                const messageTypeIdEnc =messageTypeIdEncResult.result;
                           
                return this.httpClientService.get<CommunicationTemplateDTO>(environment.eSimApi +
                                                                            eSimApiPaths.CommConfig + "/" +
                                                                            eSimApiPaths.GetCompanyCommunicationTemplate + 
                                                                            "?companyIdEncSS=" + companyIdEncSS +
                                                                            "&messageTypeIdEnc=" + messageTypeIdEnc +
                                                                            "&deliveryTypeIdEnc=" + deliveryTypeIdEnc); 
              })
            );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getCommunicationTemplates(companyId: number, messageTypeId?: number): Observable<CommunicationTemplateDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;

                            return this.httpClientService.get<CommunicationTemplateDTO[]>(environment.eSimApi +
                                                                                          eSimApiPaths.CommConfig + "/" +
                                                                                          eSimApiPaths.GetCompanyCommunicationTemplates +
                                                                                          "?companyIdEncSS=" + companyIdEncSS +
                                                                                          (messageTypeId != undefined ? "&messageTypeId=" + messageTypeId : ""));
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getCommunicationAlertTemplates(companyId: number, alertId: number, alertTypeId: number): Observable<CommunicationTemplateDTO[]> {
    try {
      return forkJoin({
               alertIdEncResult    : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>alertId),
               alertTypeIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>alertTypeId),
               companyIdEncResult  : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             })
             .pipe(
               switchMap(({ alertIdEncResult, alertTypeIdEncResult, companyIdEncResult }) => {
                 const alertIdEnc    =alertIdEncResult.result;
                 const alertTypeIdEnc=alertTypeIdEncResult.result;
                 const companyIdEncSS=companyIdEncResult.result;
                 
                 return this.httpClientService.get<CommunicationTemplateDTO[]>(
                          environment.eSimApi +
                          eSimApiPaths.CommConfig + "/" +
                          eSimApiPaths.GetCompanyAlertCommunicationTemplates +
                          "?companyIdEncSS="  + companyIdEncSS +
                          "&alertIdEnc="      + alertIdEnc +
                          "&alertTypeIdEnc="  + alertTypeIdEnc
                        );
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getCompanyCommunicationTemplatesDefaults(companyId: number): Observable<CommunicationTemplatesDefaultsDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<CommunicationTemplatesDefaultsDTO>(environment.eSimApi +
                                                                                                 eSimApiPaths.CommConfig + "/" +
                                                                                                 eSimApiPaths.CommConfigCompanyCommTemplatesDefaults +
                                                                                                 "?companyIdEncSS=" + companyIdEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getCommunicationTemplateReplacements(userId: number, messageTypeId: number): Observable<CommunicationTemplateReplacements[]> {
    try {
      return forkJoin({
               userIdEncResult       : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true),
               messageTypeIdEncResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>messageTypeId)
             })
             .pipe(
                switchMap(({ userIdEncResult, messageTypeIdEncResult }) => {
                            const userIdEncSS     =userIdEncResult.result;
                            const messageTypeIdEnc=messageTypeIdEncResult.result;
                            
                            return this.httpClientService.get<CommunicationTemplateReplacements[]>(environment.eSimApi +
                                                                                                   eSimApiPaths.CommConfig + "/" +
                                                                                                   eSimApiPaths.GetCommunicationTemplateReplacements +
                                                                                                   "?userIdEncSS=" + userIdEncSS +
                                                                                                   "&messageTypeIdEnc=" + messageTypeIdEnc, undefined);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public GetCompanyUnallocatedTemplates(companyId: number): Observable<CommunicationTemplateDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<CommunicationTemplateDTO[]>(environment.eSimApi +
                                                                                          eSimApiPaths.CommConfig + "/" +
                                                                                          eSimApiPaths.CommConfigCompanyUnallocatedTemplates +
                                                                                          "?companyIdEncSS=" + companyIdEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getCompanyDefaultTemplates(companyId: number): Observable<CommunicationTemplateDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<CommunicationTemplateDTO[]>(environment.eSimApi +
                                                                                          eSimApiPaths.CommConfig + "/" +
                                                                                          eSimApiPaths.CommConfigCompanyDefaultTemplates +
                                                                                          "?companyIdEncSS=" + companyIdEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public createCompanyCommunicationTemplateDefaults(companyDefaults: CommunicationTemplatesDefaults): Observable<void> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(companyDefaults))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.CommConfig + "/" +
                                                               eSimApiPaths.CommConfigCreateCompanyCommunicationTemplateDefaults +
                                                               "?objectEnc=" + objectEnc, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public editCommunicationTemplate(commTemplate: CommunicationTemplate): Observable<number> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(commTemplate))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.put(environment.eSimApi +
                                                              eSimApiPaths.CommConfig + "/" +
                                                              eSimApiPaths.CommConfigEditCommunicationTemplate +
                                                              "?objectEnc=" + objectEnc, undefined, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public createCommunicationTemplate(commTemplate: CommunicationTemplate): Observable<number> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(commTemplate))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.CommConfig + "/" +
                                                               eSimApiPaths.CommConfigCreateCommunicationTemplate +
                                                               "?objectEnc=" + objectEnc, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public SendTestCommunication(templateId : number, iccid : string, enteredById : number ): Observable<boolean> {
    try {
      return forkJoin({
               templateIdEncSSResult: this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>templateId, true),
               iccidEncResult       : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>iccid),
               enteredByIdEncResult : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>enteredById)
             })
             .pipe(
                switchMap(({ templateIdEncSSResult, iccidEncResult, enteredByIdEncResult }) => {
                            const templateIdEncSS=templateIdEncSSResult.result;
                            const iccidEnc       =iccidEncResult.result;
                            const enteredByIdEnc =enteredByIdEncResult.result;
                            
                            return this.httpClientService.get<boolean>(environment.eSimApi +
                                                               eSimApiPaths.CommConfig + "/" +
                                                               eSimApiPaths.CommConfigSendTestCommunications +
                                                               "?templateIdEncSS=" + templateIdEncSS + 
                                                               "&iccidEnc=" + iccidEnc +
                                                               "&enteredByIdEnc=" + enteredByIdEnc, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public updateCompanyCommConfigs(commConfigs: CommConfig[]): Observable<void> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(commConfigs))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.CommConfig + "/" +
                                                               eSimApiPaths.CommConfigUpdateCompanyCommConfigs,
                                                               { objectEncSS: encResult.result });
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public enableCompanyTemplate(commTemplateAlloc: CommunicationTemplateAllocation): Observable<void> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(commTemplateAlloc))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.put(environment.eSimApi +
                                                              eSimApiPaths.CommConfig + "/" +
                                                              eSimApiPaths.CommConfigEnableCompanyTemplate +
                                                              "?objectEnc=" + objectEnc, undefined, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public deleteCommunicationTemplates(id: number): Observable<void> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.delete(environment.eSimApi +
                                                                 eSimApiPaths.CommConfig + "/" +
                                                                 eSimApiPaths.DeleteCompanyCommunicationTemplate + 
                                                                 "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
